import { styled } from "@mui/material/styles"
import { ReactNode } from "react"

type Props = {
  direction: "horizontal" | "vertical"
  children: ReactNode
}

export function RoundedToolbar({ direction, children }: Props) {
  return (
    <RoundedToolbarDiv
      sx={{ flexDirection: direction == "horizontal" ? undefined : "column" }}
    >
      {children}
    </RoundedToolbarDiv>
  )
}

const RoundedToolbarDiv = styled("div")({
  background: "white",
  padding: "2px",
  display: "flex",
  alignItems: "center",
  borderRadius: "999px",
  boxShadow: "1px 1px 3px rgba(0,0,0,0.3)",
  gap: 2,
})
